interface LoadingSpinnerProps {
  className?: string;
  fullScreen?: boolean;
}

const LoadingSpinner = ({ className = "", fullScreen = false }: LoadingSpinnerProps) => {
  const spinner = (
    <div className={`animate-spin rounded-full h-8 w-8 border-b-2 border-primary ${className}`}></div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;
